/**
 * @module InfoCard
 */

import Component from '../base/Component';
import './styles.css';

/**
 * Мини-карточка с инфой.
 */
export default class InfoCard extends Component {
    static className = 'info-card';
}
